import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  finalize,
  retry,
  switchMap,
} from 'rxjs';
import Swal from 'sweetalert2';
import { PopularAirlinesSharedService } from '../../../../components/popular-airlines/services/popular-airlines-shared.service';
import { AlertMsgModel, ResultLinkObject } from '../../../interfaces';
import { FlightSearchApiService } from '../../../services/flight-search/services/flight-search-api.service';
import { FlightSearchService } from '../../../services/flight-search/services/flight-search.service';
import { HomePageService } from '../../../services/home-page/services/home-page.service';
import { SharedService } from '../../../services/shared.service';
import { StorageService } from '../../../services/storage-services.service';
import { IAirPortTranslated } from '../../../../components/popular-airlines/models/airlineInfo.models';
@Component({
  selector: 'app-round-trip',
  templateUrl: './round-trip.component.html',
  styleUrls: ['./round-trip.component.scss'],
})
export class RoundTripComponent implements OnInit {
  searchbox = inject(FlightSearchService);
  homePageService = inject(HomePageService);
  translate = inject(TranslateService);
  sharedService = inject(SharedService);
  router = inject(Router);
  sharedAirlineService = inject(PopularAirlinesSharedService);
  flightSearchApi = inject(FlightSearchApiService);
  searchInput$ = new Subject<string>();
  mappedResults: any[] = [];

  showDatePicker: boolean = true;
  hoveredDate: NgbDate | null = null;
  fromDate!: NgbDate;
  toDate: NgbDate | null = null;
  startDateValue: any;
  endDateValue: any;
  lang: string = 'en';
  count: number = 0;
  currency?: string;
  resultLink?:
    | string
    | {
        adult: AlertMsgModel;
        child: AlertMsgModel;
        infant: AlertMsgModel;
        retDate: AlertMsgModel;
        depDate: AlertMsgModel;
      };
  selectedValue?: string;
  adultValid: boolean = true;
  childValid: boolean = true;
  infantValid: boolean = true;
  openClass: boolean = false;
  minDate!: NgbDate;
  @ViewChild('roundTripDCalenderTrigger')
  roundTripDCalenderTrigger!: ElementRef;
  @ViewChild('roundTripRCalenderTrigger')
  roundTripRCalenderTrigger!: ElementRef;
  isReturnDateFocused: boolean = false;
  private modalService = inject(NgbModal);

  @ViewChild('mobileIssuedCountryDepart')
  mobileIssuedCountryDepart!: ElementRef;
  @ViewChild('mobileIssuedCountryLanding')
  mobileIssuedCountryLanding!: ElementRef;
  @ViewChild('departInput') departInput!: ElementRef;
  @ViewChild('landingInput') landingInput!: ElementRef;

  isSearching: boolean = false;
  isLoading: boolean = false;
  searchLoader = false;
  //#endregion
  constructor(
    public calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.minDate = this.calendar.getToday();
    if (this.searchbox.flightsArray.at(0).get('departingD')?.value) {
      this.fromDate = calendar.getToday();
      this.fromDate.year = new Date(
        this.searchbox.flightsArray.at(0).get('departingD')?.value,
      ).getFullYear();
      this.fromDate.month =
        new Date(
          this.searchbox.flightsArray.at(0).get('departingD')?.value,
        ).getMonth() + 1;
      this.fromDate.day = new Date(
        this.searchbox.flightsArray.at(0).get('departingD')?.value,
      ).getDate();
      // this.fromDate.day = Number(this.searchbox.flightsArray.at(0).get('departingD')?.value.toString().split(' ')[2])

      this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
      this.toDate.year = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getFullYear();
      this.toDate.month =
        new Date(
          this.searchbox.searchFlight.get('returnDate')?.value,
        ).getMonth() + 1;
      this.toDate.day = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getDate();
    } else {
      this.fromDate = calendar.getToday();
      this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    }
  }

  ngOnInit(): void {
    this.sharedService.cities = [...this.sharedService.initialRecommendedAirports];
    this.searchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchTerm) => {
          this.isLoading = true;
          this.sharedService.cities = [];
          return this.flightSearchApi
            .getSearchFlowMapping(searchTerm)
            .pipe(
              retry(3),
              finalize(() => {
                this.isLoading = false;
              }),
            );
        }),
      )
      .subscribe({
        next: (results) => {
          this.sharedService.cities = results;
        },
        error: (err) => {
          console.error('API error:', err);
          this.isLoading = false;
        },
      });

    let day = 0;
    let month = 0;
    let year = 0;
    year = new Date(
      this.searchbox.flightsArray.at(0).get('departingD')?.value,
    ).getFullYear();
    month =
      new Date(
        this.searchbox.flightsArray.at(0).get('departingD')?.value,
      ).getMonth() + 1;
    day = new Date(
      this.searchbox.flightsArray.at(0).get('departingD')?.value,
    ).getDate();
    this.startDateValue = { year: year, month: month, day: day };
  }
  onInputFocus(inputName: string) {
    if (inputName === 'returnDate') {
      this.isReturnDateFocused = true;
    } else {
      this.isReturnDateFocused = false;
    }
  }

  onCitySearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value.trim();

    if (searchTerm) {
      this.isSearching = true;
      this.searchInput$.next(searchTerm);
    } else {
      this.isSearching = false;
      this.isLoading = false;
      this.sharedService.cities = this.getRecommendedAirports();
    }
  }

  closeCalander() {
    this.roundTripDCalenderTrigger.nativeElement.click();
    this.roundTripRCalenderTrigger.nativeElement.click();
  }

  //update date value from form Array
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.searchbox.searchFlight
        .get('returnDate')
        ?.setValue(
          new Date(this.toDate?.year, this.toDate?.month - 1, this.toDate?.day),
        );
    } else if (
      this.fromDate &&
      this.toDate &&
      date.after(this.fromDate) &&
      this.isReturnDateFocused
    ) {
      this.toDate = date;
      this.searchbox.searchFlight
        .get('returnDate')
        ?.setValue(
          new Date(this.toDate?.year, this.toDate?.month - 1, this.toDate?.day),
        );
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.searchbox.flightsArray
      .at(0)
      .get('departingD')
      ?.setValue(
        new Date(
          this.fromDate?.year,
          this.fromDate?.month - 1,
          this.fromDate?.day,
        ),
      );
  }
  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  isDisabled(date: NgbDate) {
    date.before(this.minDate);
  }
  showDate() {
    this.showDatePicker = true;
  }
  showMobileDate(index: number, type: string) {
    if (type == 'returnDate') {
      this.sharedService.roundTripDatepickerMobileView = true;
    }
    this.router.navigate([`/searchboxMob/${index}`]);
  }
  showTravellers() {
    this.showDatePicker = false;
  }
  //get total Passengers
  getTotalPassenger() {
    let adult = this.searchbox.searchFlight?.get('passengers.adults')?.value;
    let child = this.searchbox.searchFlight?.get('passengers.child')?.value;
    let infant = this.searchbox.searchFlight?.get('passengers.infant')?.value;
    return this.searchbox.getTotalPassengers(adult, child, infant);
  }
  removeInput(inputType: string, index: number) {
    if (inputType == 'depart') {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(index)
        .get('departing')
        ?.reset();
    } else {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(index)
        .get('landing')
        ?.reset();
    }
    this.searchbox.searchFlight.updateValueAndValidity();
  }

  submit() {
    this.lang =
      this.translate.currentLang != null ? this.translate.currentLang : 'en'; // Get language
    this.currency = this.homePageService.selectedCurrency.Currency_Code; // Get currency from homepage service

    // Call submit function from searchbox service
    this.resultLink = this.searchbox.onSubmit(
      this.lang,
      // this.currency,
      'EGP',
      this.homePageService.pointOfSale
        ? this.homePageService.pointOfSale.country!
        : 'EG',
      1,
      ',',
      this.sharedAirlineService.preferredAirlineIatacode,
    );

    // Type guard to check if resultLink is of type ResultLinkObject
    if (this.isResultLinkObject(this.resultLink)) {
      // Loop through resultLink object for validation messages
      Object.entries(this.resultLink).forEach(([key, value]) => {
        if (value.enMsg) {
          this.tinyAlert(this.lang === 'en' ? value.enMsg : value.arMsg);
        }
      });
      this.searchbox.searchFlight.updateValueAndValidity();
    } else if (typeof this.resultLink === 'string' && this.resultLink) {
      // Check if form is valid before proceeding
      if (this.searchbox.searchFlight.valid) {
        // Store form data using StorageService
        this.storageService.setItem(
          'form',
          JSON.stringify(this.searchbox.searchFlight.value),
        );
        this.sharedService.saveSelectedAirportsInStorage();

        // Construct external URL
        const externalBase = 'https://flight.travasky.com/flightResult/';
        const splittedLink = this.resultLink.toString().split('/');
        const externalUrl = externalBase + splittedLink.join('/');

        if (isPlatformBrowser(this.platformId)) {
          window.location.href = externalUrl + '?form=' + JSON.stringify(this.searchbox.searchFlight.value);
        }
        // Redirect to external site
      } else {
        this.searchbox.searchFlight.markAllAsTouched();
      }
    } else {
      console.error('Unexpected type for resultLink:', this.resultLink);
    }
  }

  // Type guard to check if resultLink is of type ResultLinkObject
  private isResultLinkObject(
    resultLink: unknown,
  ): resultLink is ResultLinkObject {
    return (
      typeof resultLink === 'object' &&
      resultLink !== null &&
      'adult' in resultLink &&
      'child' in resultLink &&
      'infant' in resultLink &&
      'retDate' in resultLink &&
      'depDate' in resultLink
    );
  }
  tinyAlert(message: any) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  }

  changeAdultValue(action: string) {
    if (this.searchbox.searchFlight?.get('passengers.adults')?.value >= 9) {
      if (action == 'increase') {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(9);
        this.adultValid = false;
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
        this.adultValid = true;
      }
    } else if (
      this.searchbox.searchFlight?.get('passengers.adults')?.value <= 1
    ) {
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
        this.adultValid = true;
      } else {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(1);
      }
    } else {
      this.adultValid = true;
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
      }
    }
  }
  changeChildValue(action: string) {
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value + 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value >= 8) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(8);
        this.childValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value - 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(0);
        this.childValid = true;
      }
    }
  }
  changeInfantValue(action: string) {
    let adultValue =
      this.searchbox.searchFlight?.get('passengers.adults')?.value;
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value + 1,
        );
      this.infantValid = true;
      let infantValue =
        this.searchbox.searchFlight?.get('passengers.infant')?.value;
      if (infantValue > 4) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(4);
        this.infantValid = false;
      }
      if (infantValue > adultValue) {
        this.searchbox.searchFlight
          ?.get('passengers.infant')
          ?.setValue(adultValue);
        this.infantValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value - 1,
        );
      this.infantValid = false;
      if (this.searchbox.searchFlight?.get('passengers.infant')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(0);
        this.infantValid = true;
      }
    }
  }
  stopMenuClosing(event: any) {
    event.stopPropagation();
  }
  InFlightResult(): boolean {
    const currentUrl = this.router.url;
    return currentUrl.includes('flightResult');
  }

  onSelectLandingCity(city: IAirPortTranslated) {
    this.sharedService.onSelectLandingAirports(city, 0);
  }

  onSelectDepartingCity(city: IAirPortTranslated) {
    this.sharedService.onSelectDepartingAirports(city, 0);
  }

  openDepartAirport(depart: TemplateRef<any>) {
    this.searchbox.flightsArray.at(0).get('departing')?.setValue('');
    this.modalService.open(depart, { fullscreen: true });
    setTimeout(() => {
      document.getElementById('departInput')?.focus();
    }, 300);
  }
  assignCountriesForMobileD(departCountry: any, index: number, city: IAirPortTranslated) {
    const mobileInput = this.mobileIssuedCountryDepart.nativeElement;

    this.sharedService.onSelectDepartingAirports(city, 0);

    if (mobileInput) {
      mobileInput.value = departCountry;
      this.searchbox.flightsArray
        .at(index)
        .get('departing')
        ?.setValue(departCountry);
    }
    this.modalService.dismissAll();
  }

  openLandingAirport(landing: TemplateRef<any>) {
    this.searchbox.flightsArray.at(0).get('landing')?.setValue('');
    this.modalService.open(landing, { fullscreen: true });
    setTimeout(() => {
      document.getElementById('landingInput')?.focus();
    }, 300);
  }
  assignCountriesForMobileA(landingCountry: any, index: number, city: IAirPortTranslated) {
    const mobileInput = this.mobileIssuedCountryLanding.nativeElement;

    this.sharedService.onSelectLandingAirports(city, 0);

    if (mobileInput) {
      mobileInput.value = landingCountry;
      this.searchbox.flightsArray
        .at(index)
        .get('landing')
        ?.setValue(landingCountry);
    }
    this.modalService.dismissAll();
  }

  onSearchInputChange(event: any) {
    const inputValue = (event.target as HTMLInputElement)?.value || '';
    this.isSearching = inputValue.trim().length > 0;
  }
  getRecommendedAirports(): IAirPortTranslated[] {
    return this.sharedService.initialRecommendedAirports;
  }
}
